/** @format */
import { DirectLine } from 'botframework-directlinejs';

const cardActionMiddleware = function (dl: DirectLine) {
  return function () {
    return function (next: any) {
      return function (cardAction: any) {
        // //console.log('cardaction::' + JSON.stringify(cardAction));
        //console.log('cardactiontype: ' + cardAction.cardAction.type);
        // log message
        if (cardAction.cardAction.type == 'openUrl') {
          dl.postActivity({
            type: 'event',
            name: 'openUrlClicked',
            value: cardAction.cardAction.value,
            from: {
              id: 'abcdef',
            },
          })
            .toPromise()
            .then(() => {
              //console.log('openUrlClicked event send');
            });
        }
        // end log message

        if (
          ('call' === cardAction.cardAction.type ||
            'downloadFile' === cardAction.cardAction.type ||
            'openUrl' === cardAction.cardAction.type ||
            'playAudio' === cardAction.cardAction.type ||
            'playVideo' === cardAction.cardAction.type ||
            'showImage' === cardAction.cardAction.type) && // exception for festo (legacy)
          (cardAction.cardAction.value.includes(
            'login.festo.com/adfs/oauth2/'
          ) ||
            // exception for festo (legacy)
            cardAction.cardAction.value.includes(
              'stagelogin.festo.com/adfs/oauth2/'
            ) ||
            // every url with "showinpopupwindow." in its path will be opened in a new window
            cardAction.cardAction.value.includes('showinpopupwindow.'))
        ) {
          cardAction.cardAction.value = cardAction.cardAction.value.replace(
            'showinpopupwindow.',
            ''
          );

          //console.log(cardAction.cardAction.value);
          //console.log('poppupping...');
          const url = cardAction.cardAction.value;
          window.open(
            url,
            '_blank',
            'width=600,height=600,status=yes,scrollbars=yes,resizable=yes'
          );

          //if (popup !== null) popup.location.href = url;

          return {}; //
        } else if (
          ('call' === cardAction.cardAction.type ||
            'downloadFile' === cardAction.cardAction.type ||
            'openUrl' === cardAction.cardAction.type ||
            'playAudio' === cardAction.cardAction.type ||
            'playVideo' === cardAction.cardAction.type ||
            'showImage' === cardAction.cardAction.type) &&
          cardAction.cardAction.value.includes('contactSalesTeamButton')
        ) {
          // if (directLine != null)
          //   directLine
          //     .postActivity({
          //       type: 'event',
          //       name: 'salesButtonClicked',
          //       value: '',
          //       from: {
          //         id: '123',
          //       },
          //     })
          //     .toPromise()
          //     .then(() => {
          //       //console.log('dl salesButtonClicked-event send');
          //     });
          const event = new CustomEvent('salesButtonClicked', {});
          window.dispatchEvent(event);
          window.parent.postMessage('salesButtonClicked', '*');
          //console.log(event);
        } else {
          // normal handling (= no popup)
          return next(cardAction);
        }
      };
    };
  };
};

export default cardActionMiddleware;
